import { get } from 'lodash';

const styles = ({ color, fontSize, margin, padding, typography }) => ({
  details: {
    margin: 36,
    padding: get(padding, 'p36'),
    backgroundColor: color.uiBackground,
  },
  keysSubtitleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  notificationWidthClass: {
    width: '90%',
    padding: '0 15px',
    margin: '0 auto',
    fontWeight: 800,
  },
  categoryStart: {
    color: 'red !important',
  },
  categoryUrgent: {
    color: 'orange !important',
  },
  categoryNoExpiry: {
    color: 'green !important',
  },
  categoryField: {
    display: 'inline-block',
    marginBottom: '0 !important',
    marginLeft: 8,
    marginRight: 8,
    marginTop: '0 !important',
    width: 72,
  },
  categoryTextField: {
    paddingBottom: '0 !important',
    paddingTop: '0 !important',
  },
  categoryListItem: {
    height: 48,
  },
  categoryListItemText: {
    alignItems: 'center',
    display: 'inline-flex',
  },
  categoryStartItemIcon: {
    color: '#FF944D !important',
    minWidth: 32,
  },
  categoryUrgentItemIcon: {
    color: '#B30303 !important',
    minWidth: 32,
  },
  categoryNoExpiryItemIcon: {
    color: '#306204 !important',
    minWidth: 32,
  },
  errorText: {
    color: '#B30303',
  },
  emptyBlock: {
    height: 40,
  },
  expiryJobButtonContainer: {
    display: 'inline-flex',
  },
  expireJobBtn: {
    width: 240,
  },
  expireJobBtnHelpText: {
    fontSize: get(fontSize, 'smallText'),
  },
  expireJobBtnHelpTextContainer: {
    marginLeft: 12,
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
  reportField: {
    marginRight: 20,
    width: 200,
  },
  reportFieldContainer: {
    display: 'inline-flex',
  },
  reportingJobButtonContainer: {
    display: 'inline-flex',
    marginTop: 12,
  },
  reportingJobBtn: {
    width: 180,
  },
  secretLabelContainer: {
    marginTop: get(margin, 'm12'),
  },
  secretLabel: {
    fontFamily: get(typography, 'pageTitle'),
  },
  sharedSecretControls: {
    marginBottom: get(margin, 'm12'),
    marginTop: get(margin, 'm12'),
  },
  switchHelpText: {
    marginTop: get(margin, 'm8'),
  },
});

export default styles;
